export default __webpack_public_path__ + "static/media/gamestack-list-large.89dd2fc9.jpg";